import { env } from "~/env.mjs";

let baseUrl: string = "https://app.getriver.io";
if (process.env.NODE_ENV === "development") baseUrl = "http://localhost:3000";

export const getImagePath = (eventImage?: string | null, eventId?: string) => {
    return eventImage?.startsWith("http")
        ? eventImage
        : `${env.NEXT_PUBLIC_ASSETS_URL}/${eventId}/${eventImage}`;
};

export const getEventImageUrl = (
    event: {
        id: string;
        image: string | null;
        city: string | null;
    },
    communitySlug?: string,
    brandAssetUrl?: string | null,
) => {
    const { id, image, city } = event;

    if (!image) return `${env.NEXT_PUBLIC_ASSETS_URL}/city/upload-photo.png`;

    const currentEventImage = image.startsWith("http")
        ? image
        : `${env.NEXT_PUBLIC_ASSETS_URL}/${id}/${image}`;

    if (brandAssetUrl && image) {
        return makeEventImageUrl(
            currentEventImage,
            city ?? "Meetup",
            communitySlug,
            brandAssetUrl,
        );
    }

    return currentEventImage;
};

export const makeEventImageUrl = (
    image: string,
    city: string,
    communitySlug?: string,
    brandAssetUrl?: string | null,
) => {
    const urlLink = encodeURIComponent(image);
    const params = new URLSearchParams();

    if (communitySlug) params.append("communitySlug", communitySlug);
    params.append("cityName", encodeURIComponent(city));
    if (brandAssetUrl) params.append("brandAssetUrl", brandAssetUrl);
    params.append("eventImage", urlLink);

    return `${baseUrl}/api/og/event-image?${params.toString()}`;
};

export const getDownscaledImageURL = (key: string) => {
    // harcoding for now since this lambda can access both buckets
    const apiEndpoint = "https://d3fhbe8dp3vwwl.cloudfront.net";
    const imageRequest = JSON.stringify({
        bucket: `${env.NEXT_PUBLIC_ASSETS_URL.replace(/^https?:\/\//, "")}`,
        key,
        edits: {
            resize: {
                width: 2048,
                height: 2048,
                fit: "inside",
            },
        },
        outputFormat: "webp",
    });
    const encodedObject = btoa(imageRequest);
    return `${apiEndpoint}/${encodedObject}`;
};

export const DEFAULT_IMAGES =
    "image/png, image/gif, image/jpeg, image/webp, image/jpg";
export const DEFAULT_VIDEOS = "video/mp4, video/mpeg, video/webm";

const videoExtensions = DEFAULT_VIDEOS.split(",").map(
    (c) => "." + c.trim().split("/").at(-1),
);

const imageExtensions = DEFAULT_IMAGES.split(",").map(
    (c) => "." + c.trim().split("/").at(-1),
);

export const isVideo = (filnename: string) => {
    for (const ext of videoExtensions) {
        if (filnename.toLowerCase().endsWith(ext)) return true;
    }
    return false;
};

export const isImage = (filnename: string) => {
    const ext = "." + (filnename.toLowerCase().split(".").slice(-1)[0] ?? "");
    if (imageExtensions.includes(ext)) return true;
    return false;
};

export enum AcceptType {
    VIDEO = DEFAULT_VIDEOS,
    IMAGE = DEFAULT_IMAGES,
}
